import { useDebouncedCallback } from "@mantine/hooks";
import { useEffect } from "react";

import type { NullableNumberRange } from "./numberInput.js";

const RANGE_INPUT_DEBOUNCE_MS = 300;

export function useDebouncedRangeCommit({
  onChange,
  onRejected,
  value,
}: {
  readonly onChange: (value: NullableNumberRange) => boolean | void;
  readonly onRejected?: () => void;
  readonly value: NullableNumberRange;
}) {
  const commit = useDebouncedCallback((next: NullableNumberRange) => {
    if (onChange(next) === false) onRejected?.();
  }, {
    delay: RANGE_INPUT_DEBOUNCE_MS,
    flushOnUnmount: false,
  });

  useEffect(() => {
    commit.cancel();
  }, [commit, value.max, value.min]);

  return {
    cancel: () => commit.cancel(),
    flush: () => commit.flush(),
    schedule: (next: NullableNumberRange) => commit(next),
  } as const;
}
